import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { MovementTypeEnum } from "../../../../pages/financeiro/schema/gerar-movimentacao-obra.schema";
import { SelectField } from "../../ui";

interface PlanoDeContasOption {
  id: string;
  description: string;
  code: string;
  accountType: string;
}

interface InputPlanoDeContasProps {
  name: string;
  label: string;
  methods: any;
  helperText?: string;
  disabled?: boolean;
  tiPosMovimentacao?: MovementTypeEnum;
  planoSelecionado?: (planos: PlanoDeContasOption[]) => void;
}

export default function InputPlanoDeContas({
  name,
  label,
  methods,
  helperText,
  disabled = false,
  tiPosMovimentacao,
  planoSelecionado,
}: InputPlanoDeContasProps) {
  const { control, formState } = methods;
  const { errors } = formState;
  const [planos, setPlanos] = useState<PlanoDeContasOption[]>([]);
  const [planosPorTipo, setPlanosPorTipo] = useState<PlanoDeContasOption[]>([]);

  useEffect(() => {
    const fetchPlanos = async () => {
      const response = await baseApiService.get("chart-of-accounts/select");
      setPlanos(response.data.data || []);
    };
    fetchPlanos();
  }, []);

  useEffect(() => {
    if (planoSelecionado) {
      planoSelecionado(
        planos.map((plano) => ({
          id: plano.id,
          description: plano.description,
          code: plano.code,
          accountType: plano.accountType,
        }))
      );
    }
  }, [planoSelecionado, planos]);


  useEffect(() => {
    if (tiPosMovimentacao) {
      const filteredPlanos = planos.filter(
        (plano) => plano.accountType === tiPosMovimentacao
      );
      setPlanosPorTipo(filteredPlanos);
    } else {
      setPlanosPorTipo(planos);
    }
  }, [tiPosMovimentacao, planos]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SelectField
          label={label}
          error={!!errors[name]}
          helperText={errors[name]?.message?.toString() || helperText}
          disabled={disabled}
          value={field.value || ""}
          onChange={(event) => field.onChange(event.target.value)}
        >
          <option value="">Selecione...</option>
          {planosPorTipo.map((plano) => (
            <option key={plano.id} value={plano.id}>
              {plano.code} - {plano.description}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
